export interface IModuleParams {
    [key: string]: string | number | undefined | object
}

export interface IParamAction {
    type: string,
    payload?: IModuleParams
}

const paramDefault = {}

function paramReducer(state: IModuleParams = paramDefault, action: IParamAction): IModuleParams {
// console.log(action.type);
// console.log(Object.assign({}, state, action.payload));

    switch (action.type) {
        case "PARAM_UPDATE":
            return Object.assign({}, state, action.payload);
        case "PARAM_CLEAR":
            return {}
        case "PROGRESS_CLEAR":
            return paramDefault;
        default:
            return state;
    }
}

export default paramReducer;